import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@components/ProtectedRoute";
import { AppLayout } from "@components/Layout";
import Home from "@pages/Home";
import PreviewPage from "@pages/PreviewPage";
import Account from "@pages/Account";
import Players from "@pages/Players";
import Teams from "@pages/Teams";
import LiveMatch from "@pages/LiveMatch";
import History from "@pages/History";
import Statistics from "@pages/Statistics";
import Settings from "@pages/Settings";
import BonusPoints from "@pages/BonusPoints";

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/preview", element: <PreviewPage /> },
      { path: "/account", element: <Account /> },
      {
        element: <ProtectedRoute />,
        children: [
          { path: "/players", element: <Players /> },
          { path: "/teams", element: <Teams /> },
          { path: "/matches/:id/live", element: <LiveMatch /> },
          { path: "/history", element: <History /> },
          { path: "/statistics", element: <Statistics /> },
          { path: "/bonus", element: <BonusPoints /> },
          { path: "/settings", element: <Settings /> },
        ],
      },
    ],
  },
]);
